import * as components from '~/assets/theme/components';

export default defineAppConfig({
    ui: {
        colors: {
            primary: 'indigo',
        },
        icons: {
            close: 'i-lucide-x',
        },
        ...components,
    },
});
